const axios = require("axios");
import firebase from "firebase";
const db = firebase.firestore();

// Usage

// import sendNotification from "@/services/sendNotification";
// sendNotification(
//   "This is the Subject for Email",
//   ["qRHu6MowNROFkszkDxTDJDaxqyC2"],
//   ["email", "sms", "whatsapp"],
//   "Hello from JourneyBinder",
//   "Zaid",
//   "d-32d0699b4b634609a39ce9b2340ca36"
// )
//   .then(res => {
//     console.log("sent", res);
//   })
//   .catch(e => {
//     console.log("error", e);
//   });

const sendNotification = function(
  subject,
  user_ids,
  types,
  msg,
  from = null,
  template_id = "d-32d0699b4b634609a39ce9b2340ca363"
) {
  return new Promise((resolve, reject) => {
    user_ids.forEach(async user => {
      if (typeof user == "object") {
        types.forEach(notify_type => {
          switch (notify_type) {
            case "email":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  subject: subject,
                  to: user.email,
                  type: "email",
                  msg: msg,
                  from: from,
                  templateId: template_id
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;

            case "sms":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  to: user.phoneNumber,
                  type: "sms",
                  msg: msg,
                  from: from
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;

            case "whatsapp":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  to: user.phoneNumber,
                  type: "whatsapp",
                  msg: msg,
                  from: from
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;

            case "voice":
              axios({
                method: "post",
                url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                data: {
                  to: user.phoneNumber,
                  type: "voice",
                  msg: msg,
                  from: from
                }
              })
                .then(res => {
                  resolve(res);
                })
                .catch(e => {
                  reject(e);
                });
              break;

            default:
              reject({
                message: "method not found",
                code: 404,
                status: "error"
              });
              break;
          }
        });
      } else if (typeof user == "string") {
        let userRef = db.collection("users").doc(user);
        let user_doc = await userRef.get();
        let user_data = user_doc.data();
        if (user_data.settings) {
          types.forEach(notify_type => {
            switch (notify_type) {
              case "email":
                if (user_data.settings.notifications.email) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      subject: subject,
                      to: user_data.email,
                      type: "email",
                      msg: msg,
                      from: from,
                      templateId: template_id
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Email Address found.",
                    status: "error"
                  });
                }
                break;

              case "push":
                if (user_data.device_registratons) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      subject: subject,
                      to: user_data,
                      type: "push",
                      msg: msg,
                      from: from,
                      device_token: user_data.device_registratons[0].token
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Token found.",
                    status: "error"
                  });
                }
                break;

              case "sms":
                if (
                  user_data.settings.notifications.mobile &&
                  user_data.phoneNumber
                ) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.phoneNumber,
                      type: "sms",
                      msg: msg,
                      from: from
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Phone Number found.",
                    status: "error"
                  });
                }
                break;

              case "whatsapp":
                if (
                  user_data.settings.notifications.mobile &&
                  user_data.phoneNumber
                ) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.phoneNumber,
                      type: "whatsapp",
                      msg: msg,
                      from: from
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Phone Number found.",
                    status: "error"
                  });
                }
                break;

              case "voice":
                if (
                  user_data.settings.notifications.mobile &&
                  user_data.phoneNumber
                ) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.phoneNumber,
                      type: "voice",
                      msg: msg,
                      from: from
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Phone Number found.",
                    status: "error"
                  });
                }
                break;

              case "messenger":
                if (user_data.settings.notifications.mobile) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      to: user_data.messengerId,
                      type: "messenger",
                      msg: msg
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Messenger Id found.",
                    status: "error"
                  });
                }
                break;

              case "slack":
                if (user_data.settings.notifications.mobile) {
                  axios({
                    method: "post",
                    url: `https://us-central1-${process.env.VUE_APP_DB_NAME}.cloudfunctions.net/send_notification`,
                    data: {
                      to: "C018G36ECKV",
                      type: "slack",
                      msg: msg
                    }
                  })
                    .then(res => {
                      resolve(res);
                    })
                    .catch(e => {
                      reject(e);
                    });
                } else {
                  reject({
                    message: "No Slack Id found.",
                    status: "error"
                  });
                }
                break;

              default:
                reject({
                  message: "method not found",
                  code: 404,
                  status: "error"
                });
                break;
            }
          });
        } else {
          reject({
            message: "Notifications are off for this user.",
            status: "error"
          });
        }
      }
    });
  });
};

export default sendNotification;
